module.exports = __webpack_public_path__ + "assets/img/image-placeholder.42f32682.jpg";